export default __webpack_public_path__ + "static/media/mad_mimi_form.81f89192.png";